import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ButtonStyle } from '../../components/Button';
import {
  ActionBar,
  ActionBarStyle,
  ButtonAction,
} from '../../components/ActionBar';
import { Flash, WarningFlash } from '../../components/Flash';
import CardList from '../../components/CardList';
import CompanyCard from '../../components/CompanyCard';
import Page from '../../components/Page';
import { ProfileContext, Profile } from '../../profile';
import CompanyPromoCard from './CompanyPromoCard';
import StatsPromoCard from './StatsPromoCard';

const getSubtitle = (profile: Profile) =>
  profile.is_verified
    ? 'See how Filtru users have interacted with your coffee guides'
    : 'Engage with the community by creating your first brew guide.';

const getTitle = (profile: Profile) =>
  profile.is_verified ? 'Today' : 'Welcome To Filtru';

export default (props: RouteComponentProps<any>) => {
  const { profile } = React.useContext(ProfileContext);

  return (
    <Page title={getTitle(profile)} subtitle={getSubtitle(profile)}>
      {!profile.is_verified && (
        <WarningFlash text="Please check your inbox for confirmation email" />
      )}
      {profile.company && !profile.company.location.city && (
        <Flash
          text={
            'Complete your Company profile by clicking the "Brand Page" link.'
          }
        />
      )}
      <CardList className="animated fadeIn">
        {profile.company && <CompanyCard company={profile.company} />}
        <StatsPromoCard />
        <CompanyPromoCard />
      </CardList>
    </Page>
  );
};
